var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "text-center shadow-sm h-100",
    class: "border-".concat(_vm.cor)
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "gap": "0.5rem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": _vm.icone,
      "variant": _vm.cor,
      "font-scale": "1.5"
    }
  }), _c('strong', {
    staticClass: "ms-3"
  }, [_vm._v(_vm._s(_vm.titulo))])], 1), _c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "id": "tooltip-info-".concat(_vm.titulo),
      "icon": "info-circle-fill",
      "variant": "primary"
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "tooltip-info-".concat(_vm.titulo),
      "placement": "top"
    }
  }, [_vm._v(" " + _vm._s(_vm.tituloBIcon) + " ")])], 1), _c('h4', {
    class: "text-".concat(_vm.cor)
  }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(_vm.valor, 2)))]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(_vm.liquido, 2)) + " líquido")]), _c('div', {
    staticClass: "mt-2"
  }, [_c('p', [_vm._v(_vm._s(_vm.cobrancas) + " cobrança(s)")])]), _c('b-progress', {
    staticClass: "my-3",
    attrs: {
      "height": "6px",
      "variant": _vm.cor,
      "value": _vm.valor > 0 ? 100 : 0
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };